export default {
  title: {
    id: 'seller_options_integrations_title',
    defaultMessage: 'My Integrations',
  },
  withIntegrationsSubtitle: {
    id: 'seller_options_integrations_with_integrations_subtitle',
    defaultMessage:
      'To secure your tokens, you have to insert your password to access them.',
  },
  onboardingModalTitle: {
    id: 'seller_options_integrations_onboarding_modal_title',
    defaultMessage: 'Connect APIs',
  },
  onboardingModalDescription: {
    id: 'seller_options_integrations_onboarding_modal_description',
    defaultMessage:
      'Why work harder when you can work smarter? Work more efficiently by connecting APIs that will help you create listings, manage orders, and more.',
  },
  onboardingModalToDoSection: {
    id: 'seller_options_integrations_onboarding_modal_to_do_section',
    defaultMessage:
      'Start by adding the APIs you use and entering your passwords.',
  },
  onboardingModalDoneSection: {
    id: 'seller_options_integrations_onboarding_modal_done_section',
    defaultMessage: 'Head back to the Onboarding page to continue.',
  },
  onboardingModalButtonLabel: {
    id: 'seller_options_integrations_onboarding_modal_button_label',
    defaultMessage: 'Connect APIs',
  },
}
